<template>
  <div class="avecor-table" style="background:#eee !important"> 
    <!-- TABLE --->
      <!-- <AddContact :companyId="selectedCompanyId" @close="newContactDialog=false" :visible="newContactDialog" ></AddContact>-->
      <!--<v-btn @click.stop="importCompanies" color="#000000" dark class="add-button mb-2">Import</v-btn>-->
      <!--<input type="file" id="fileInput"></input>
      <button @click="importCompanies" id="submit_button">PARSE FILE</button>-->
    
    
    <v-row justify-center style="" class="pt-5 pb-5">
      <v-col cols="12" class="ma-0 pa-0 text-center">
        <v-btn @click.stop="addAddress" color="#000000" dark class="avecor-button-global add-button">
          <!-- <v-icon :size="16">far fa-plus-square</v-icon> -->
          Lisää {{ whichAddresses === 'billing' ? 'laskutusosoite' : '' }} {{ whichAddresses === 'delivery' ? 'toimitusosoite' : '' }}
        </v-btn>
      </v-col>
    </v-row>
    <div style="font-size: 10px;" class="pb-5">
      
      
      <div v-if="whichAddresses == 'delivery'">
        <v-row style="border-bottom: 1px solid #ccc;">
          <v-col cols="1"></v-col>
          <v-col cols="1">Tyyppi</v-col>
          <v-col cols="3">Osoite</v-col>
          <v-col cols="3">Kaupunki</v-col>
          <v-col cols="2">Postikoodi</v-col>
          <v-col cols="2">Maa</v-col>
        </v-row>
        <v-row v-for="a in getAddresses" :key="a.id" class="pt-2">
          <v-col cols="1" class="text-center pb-0 pt-2">
            <i @click="deleteAddress('delivery',a.id)" style="padding-right:4px;padding-top:0px;font-size:10px;color:#666" class="far fa-trash-alt pointer" />
          </v-col>
          <v-col cols="1" class="pb-0 pt-2"><span >{{ addressTypeToText[a.type] ? addressTypeToText[a.type] : '' }}</span></v-col>
          <v-col cols="3" class="pb-0 pt-1"><input style="padding:2px 4px;background:#ddd;width:100%;" :value="a.deliveryAddress" @change="v => updateAddress('delivery',a.id,'deliveryAddress',v.target.value)"></v-col>
          <v-col cols="3" class="pb-0 pt-1"><input style="padding:2px 4px;background:#ddd;width:100%;" :value="a.deliveryCity" @change="v => updateAddress('delivery',a.id,'deliveryCity',v.target.value)"></v-col>
          <v-col cols="2" class="pb-0 pt-1"><input style="padding:2px 4px;background:#ddd;width:100%;" :value="a.deliveryPostalCode" @change="v => updateAddress('delivery',a.id,'deliveryPostalCode',v.target.value)"></v-col>
          <v-col cols="2" class="pb-0 pt-1"><input style="padding:2px 4px;background:#ddd;width:100%;" :value="a.deliveryCountry" @change="v => updateAddress('delivery',a.id,'deliveryCountry',v.target.value)"></v-col>
        </v-row>
      </div>
      <div v-else-if="whichAddresses == 'billing'">
        <v-row style="border-bottom: 1px solid #ccc;">
          <v-col cols="1"></v-col>
          <v-col cols="1">Tyyppi</v-col>
          <v-col cols="2">Osoite</v-col>
          <v-col cols="2">Kaupunki</v-col>
          <v-col cols="2">Postikoodi</v-col>
          <v-col cols="1">Maa</v-col>
          <v-col cols="1">Verkkolaskuosoite</v-col>
          <v-col cols="2">Verkkolasku - operaattori</v-col>
        </v-row>
        <v-row v-for="a in getAddresses" :key="a.id" class="pt-2">
          <v-col cols="1" class="text-center pb-0 pt-2">
            <i @click="deleteAddress('billing',a.id)" style="padding-right:4px;padding-top:0px;font-size:10px;color:#666" class="far fa-trash-alt pointer" />
          </v-col>
          <v-col cols="1" class="pb-0 pt-2"><span >{{ addressTypeToText[a.type] ? addressTypeToText[a.type] : '' }}</span></v-col>
          <v-col cols="2" class="pb-0 pt-1"><input style="padding:2px 4px;background:#ddd;width:100%;" :value="a.billingAddress" @change="v => updateAddress('billing',a.id,'billingAddress',v.target.value)"></v-col>
          <v-col cols="2" class="pb-0 pt-1"><input style="padding:2px 4px;background:#ddd;width:100%;" :value="a.billingCity" @change="v => updateAddress('billing',a.id,'billingCity',v.target.value)"></v-col>
          <v-col cols="2" class="pb-0 pt-1"><input style="padding:2px 4px;background:#ddd;width:100%;" :value="a.billingPostalCode" @change="v => updateAddress('billing',a.id,'billingPostalCode',v.target.value)"></v-col>
          <v-col cols="1" class="pb-0 pt-1"><input style="padding:2px 4px;background:#ddd;width:100%;" :value="a.billingCountry" @change="v => updateAddress('billing',a.id,'billingCountry',v.target.value)"></v-col>
          <v-col cols="1" class="pb-0 pt-1"><input style="padding:2px 4px;background:#ddd;width:100%;" :value="a.eBillingAddress" @change="v => updateAddress('billing',a.id,'eBillingAddress',v.target.value)"></v-col>
          <v-col cols="2" class="pb-0 pt-1 pr-5">
            <select :value="a.eBillingOperator ? a.eBillingOperator : ''" class="" style="padding:2px 4px;background:#ddd;width:100%;" @click.stop  @change="v => updateAddress('billing',a.id,'eBillingOperator',v.target.value)">
              <option value=""></option>
              <option v-for="o in settings.eBillingOperators" :key="o.id+'_address'" :value="o.id">{{o.name}}</option>
            </select> 
            <!-- <input style="padding:2px 4px;background:#ddd;width:100%;" :value="a.eBillingOperator" @change="v => updateAddress('billing',a.id,'eBillingOperator',v.target.value)"> -->
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import dateFormat from 'dateformat'
export default {
    props: ['companyId','whichAddresses'],
    /* 
    <div class="order-expand-header-field-label" style="width:155px;">Lähetä vedos vain myyjälle</div>
                  <input style="vertical-align: middle;height:11px;margin-top:3px" type="checkbox" :checked="contacts[selectedOrder.contactId].sendDraftsToSalesperson" @change="inlineSaveContactDetails('sendDraftsToSalesperson', !contacts[selectedOrder.contactId].sendDraftsToSalesperson)"/> 
    */
    data: () => ({
      table: null,
      autogrow: true,
      selected: [],
      search: '',
      addressTypeToText:{
        company:'Yritys',
        personal:'Yksityinen'

      }
      
    }),
    mounted() {
      const table = this.$refs.table
      //console.log(this.companyId)
    },
    computed: {
      getAddresses(){
        var c = this.companies[this.companyId]
        let addresses = {}
        if(this.whichAddresses === 'billing' && c.shopBillingAddresses) addresses = c.shopBillingAddresses
        else if(this.whichAddresses === 'delivery' && c.shopDeliveryAddresses) addresses = c.shopDeliveryAddresses
        let addressesArray = []
        
        Object.keys(addresses).forEach(aId => {
          addressesArray.push(addresses[aId])
        })
        
        return addressesArray
      },
      ...mapFields([
        "company.companies",
        "contact.contacts",
        "settings",
        "user",
      ]),
    },
    watch: {
      
    },
    created () {},
    methods: {
      deleteAddress(addressType,id){
        const c = this.companies[this.companyId]
        if(addressType === 'billing'){
          this.$store.dispatch('company/delete', `${c.id}.shopBillingAddresses.${id}`)
          .then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:1500, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
        }
        else if(addressType === 'delivery'){
          this.$store.dispatch('company/delete', `${c.id}.shopDeliveryAddresses.${id}`)
          .then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:1500, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
        }
      },
      updateAddress(addressType,id,field,value){
        const c = this.companies[this.companyId]
        var addresses = {}
        if(addressType === 'billing'){
          addresses = JSON.parse(JSON.stringify(c.shopBillingAddresses))
          addresses[id][field] = value
          console.log(addresses)
          this.$store.dispatch('company/set', {
            id:this.companyId,
            shopBillingAddresses:addresses
          }).then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:2000, snackText:"Uusi rivi lisätty.", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
        }
        else if(addressType === 'delivery'){
          addresses = JSON.parse(JSON.stringify(c.shopDeliveryAddresses))
          addresses[id][field] = value
          console.log(addresses)
          this.$store.dispatch('company/set', {
            id:this.companyId,
            shopDeliveryAddresses:addresses
          }).then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:2000, snackText:"Uusi rivi lisätty.", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
        }
      },
      generateId(){
        var batchId1 = Math.random().toString(36).substr(2, 9);
        var batchId2 = Math.random().toString(36).substr(2, 9);
        return batchId1+batchId2
      },
      customFormatter(date) {
        var da = dateFormat(date, "yyyy-mm-dd")
        return da
      },
      deleteItem (item) {
        this.$store.dispatch('contact/delete', item.id)
          .then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:1000, snackText:"Kontakti poistettu.",errorType:"", snackColor:'success',right:true,top:true}))
      },
      addAddress() {
        let newId = this.generateId()
        if (this.companyId === ""){
          alert("Yritys idtä ei valittuna")
          return
        }
        const c = this.companies[this.companyId]
        var addresses = {}
        if(this.whichAddresses === 'billing'){
          if(c.shopBillingAddresses) addresses = JSON.parse(JSON.stringify(c.shopBillingAddresses))
          let address = {
            id:newId,
            billingAddress:'',
            billingCity:'',
            billingPostalCode:'',
            billingCountry:'',
            type:'company'
          }
          addresses[newId] = address
          console.log(addresses)
          console.log(this.companyId)
          this.$store.dispatch('company/set', {
            id:this.companyId,
            shopBillingAddresses:addresses
          }).then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:2000, snackText:"Uusi rivi lisätty.", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
        }
        else if(this.whichAddresses === 'delivery'){
          if(c.shopDeliveryAddresses) addresses = JSON.parse(JSON.stringify(c.shopDeliveryAddresses))
          let address = {
            id:newId,
            deliveryAddress:'',
            deliveryCity:'',
            deliveryPostalCode:'',
            deliveryCountry:'',
            type:'company'
          }
          addresses[newId] = address
          this.$store.dispatch('company/set', {
            id:this.companyId,
            shopDeliveryAddresses:addresses
          }).then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:2000, snackText:"Uusi rivi lisätty.", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
        }
      },
      inlineSave (item) {
        let {id, ...y} = item;
        this.$store.dispatch('contact/set', {
          id,
          ...y
        }).then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
      },
      inlineSaveContact(id,field,value){
        this.$store.dispatch('contact/set', {
          id,
          [field]:value
        }).then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
      },
    }
  }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/blocks/CompanyShopAddresses.vue